import { render, staticRenderFns } from "./EditMealBookListItem.vue?vue&type=template&id=70bc0fbc&scoped=true&"
import script from "./EditMealBookListItem.vue?vue&type=script&lang=ts&"
export * from "./EditMealBookListItem.vue?vue&type=script&lang=ts&"
import style0 from "./EditMealBookListItem.vue?vue&type=style&index=0&id=70bc0fbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc0fbc",
  null
  
)

export default component.exports